import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';
import { Row, Col, Button, Upload, Form, Input, Card, Table } from 'antd';
import SuccessModal from '../../SuccessModal/SuccessModal';
import WarningModal from '../../WarningModal/WarningModal';
import * as Utilities from '../../Utilities';
import AWS from 'aws-sdk';
import * as Constants from '../Constants';
import { ArrowRightOutlined, LoadingOutlined, PaperClipOutlined } from '@ant-design/icons';
import FileConstants from '../../../../FileConstants';
import DottedLoader from '../../DottedLoader';
import './Profile.scss';
import { Link } from 'react-router-dom';

let COMPANY_ID = localStorage.getItem('company_id');
const Profile = (props) => {

    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [loader, setLoader] = useState(true);
    const [customerData, setCustomerData] = useState(null);
    const [tableData, setTableData] = useState([]);
    const getCustomerInfo = () => {
        axios.post(ENVIRONMENT.GET_CUSTOMER_AND_COMPANY, { customer_username: localStorage.getItem('username') })
            .then(res => {
                setLoader(false);
                console.log(res)
                if (res?.data) {
                    if (!Array.isArray(res?.data)) {
                        setCustomerData(res.data);
                    }
                }

            })
    }

    useEffect(() => {
        getCustomerInfo();
    }, []);

    const header_cols = [
        {
            title: '0',
            dataIndex: '0',
        },
        {
            title: '1',
            dataIndex: '1',
        },
        {
            title: '2',
            dataIndex: '2',
        },
        // {
        //     title: '3',
        //     dataIndex: '3',
        // },
        {
            title: '4',
            dataIndex: '4',
        },
    ];


    let data = [{
        key: '0',
        0: <span className='manrope f-16 lh-24 w-700 black-085'>User settings</span>,
        1: <span className='manrope f-14 lh-22 w-700 black-085'>Name</span>,
        2: <span className='manrope f-14 lh-22 w-400 black-085'>{customerData?.profile_name}</span>,
        // 3: <a className='manrope f-14 lh-22 w-400 blue'></a>,
        4: <span className='manrope f-12 lh-20 w-500 black-085'></span>
    },
        {
        key: '1',
            0: <span className='manrope f-16 lh-24 w-700 black-085'></span>,
        1: <span className='manrope f-14 lh-22 w-700 black-085'>Email</span>,
        2: <span className='manrope f-14 lh-22 w-400 black-085'>{customerData?.email}</span>,
        // 3: <a className='manrope f-14 lh-22 w-400 blue'></a>,
        4: <span className='manrope f-12 lh-20 w-500 black-085'></span>
    }];

    let company_data = [{
        key: '2',
        0: <span className='manrope f-16 lh-24 w-700 black-085'>Company</span>,
        1: <span className='manrope f-14 lh-22 w-700 black-085'>Company name</span>,
        2: <span className='manrope f-14 lh-22 w-400 black-085'>{customerData?.company_display_name}</span>,
        // 3: <a className='manrope f-14 lh-22 w-400 blue'></a>,
        4: <span className='manrope f-12 lh-20 w-500 black-085'></span>
    },
    {
        key: '3',
        0: <span className='manrope f-16 lh-24 w-700 black-085'></span>,
        1: <span className='manrope f-14 lh-22 w-700 black-085'>Company size</span>,
        2: <span className='manrope f-14 lh-22 w-400 black-085'>{customerData?.company_size}</span>,
        // 3: <a className='manrope f-14 lh-22 w-400 blue'></a>,
        4: <span className='manrope f-12 lh-20 w-500 black-085'></span>
    },
    {
        key: '4',
        0: <span className='manrope f-16 lh-24 w-700 black-085'></span>,
        1: <span className='manrope f-14 lh-22 w-700 black-085'>Type of business</span>,
        2: <span className='manrope f-14 lh-22 w-400 black-085 capitalize'>{customerData?.user_type}</span>,
        // 3: <a className='manrope f-14 lh-22 w-400 blue'></a>,
        4: <span className="manrope f-12 lh-20 w-500 black-085"></span>,
      },
      {
          key: "5",
        0: <span className="manrope f-16 lh-24 w-700 black-085"></span>,
        1: (
          <span className="manrope f-14 lh-22 w-700 black-085">
            Company Website
          </span>
        ),
        2: (
          <span className="manrope f-14 lh-22 w-400 black-085 capitalize">
            {customerData?.company_website}
          </span>
        ),
        4: <span className="manrope f-12 lh-20 w-500 black-085"></span>,
      },
      {
          key: "6",
        0: <span className="manrope f-16 lh-24 w-700 black-085"></span>,
        1: (
          <span className="manrope f-14 lh-22 w-700 black-085">Job Title</span>
        ),
        2: (
          <span className="manrope f-14 lh-22 w-400 black-085 capitalize">
            {customerData?.job_title}
          </span>
        ),
        4: <span className="manrope f-12 lh-20 w-500 black-085"></span>,
      },
    ];

    useEffect(() => {
        setTableData(data.concat(company_data));
    }, [customerData]);


    const tableProps = {
        bordered: false,
        loading: false,
        size: 'large',
        expandable: false,
        title: undefined,
        showHeader: false,
        footer: false,
        rowSelection: undefined,
        scroll: undefined,
        tableLayout: 'fixed',
    };

    return (
        <div style={{ padding: '0px 10px' }}>
            {loader ? <DottedLoader /> : <Row style={{ marginTop: '24px' }}>
                <Col span={24}>
                    <Table
                        className='profile-table'
                        pagination={{
                            position: ['none', 'none'],
                        }}
                        {...tableProps}
                        columns={header_cols}
                        dataSource={tableData}
                    />
                </Col>
            </Row>}
        </div>
    );

}

export default Profile;
